import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get, isEmpty } from 'lodash';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { ReviewsModel, ReviewEntities, ReviewsPaths } from 'client/data/models/dealer-reviews';
import { DEALER_PROPS } from 'client/constants/dealer-reviews';
import { UserReview } from 'site-modules/dealerships/components/user-review/user-review';

import './dealer-reviews-per-page.scss';

function DealerReviewsPerPageComponent({ allReviewsByType, numVisible, params }) {
  const newReviews = get(allReviewsByType, 'newReviews', []);
  const oldReviews = get(allReviewsByType, 'oldReviews', []);
  const reviews = [...newReviews, ...oldReviews];
  const isLoading = isEmpty(allReviewsByType);

  return (
    <div className={classnames('dealer-reviews-per-page', { 'd-flex justify-content-center my-1': isLoading })}>
      {isLoading ? (
        <i className="spinner icon-spinner8 me-0_25" title="loading" />
      ) : (
        <ul className="list-unstyled mb-0">
          {reviews.map((item, index) => (
            <li
              className={classnames('pt-1_5', {
                'd-none': index > numVisible - 1,
              })}
              key={item.id}
            >
              <UserReview review={item} params={params} index={index} />
              {index < numVisible - 1 && index !== reviews.length - 1 && <hr className="mt-1_5 mb-0" />}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

DealerReviewsPerPageComponent.propTypes = {
  allReviewsByType: PropTypes.shape({
    allReviews: PropTypes.arrayOf(ReviewEntities.ReviewEntity),
  }),
  numVisible: PropTypes.number.isRequired,
  params: DEALER_PROPS,
};

DealerReviewsPerPageComponent.defaultProps = {
  allReviewsByType: {},
  params: {},
};

export const stateToPropsConfig = {
  allReviewsByType: {
    path: ({ type, params: { dealerId } }) =>
      ReviewsPaths.getDealershipReviewsByTypePath({
        dealerId,
        type,
      }),
    segment: ReviewsModel,
  },
};

export const DealerReviewsPerPage = connectToModel(DealerReviewsPerPageComponent, stateToPropsConfig);

DealerReviewsPerPage.propTypes = {
  params: DEALER_PROPS.isRequired,
  numVisible: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};
